import {http} from "Services/Http/HttpClient"

export const unsubscribeInscription = async (inscriptionOrderActivityId: string): Promise<unknown> => {
    return await http.put('/inscriptions/activity/' + inscriptionOrderActivityId + '/unsubscribe')
}